export default __webpack_public_path__ + "static/media/logo-footer.5a15c21f.svg";